import { ControlledSwitch, DataField, FieldsetCard, useFormContainerContext } from '@if/mui'
import { useTranslation } from 'react-i18next'
import { useWatch } from 'react-hook-form'
import { CalculatorEstimateResultDto } from '@src/types/CalculatorEstimateDto'
import { PersonalLoanCalculatorSchemaType } from '@src/types/PersonalLoanCalculatorSchema'

interface BusinessFeeDisplayProps {
  calculatedRate?: CalculatorEstimateResultDto | null
}

/**
 * The admin fee rate charged to the merchant (`merchantFeeRate`). The section exists
 * only when there is a fee (0 hides it entirely), and the rate itself sits behind a
 * switch that starts off — it concerns the merchant rather than the borrower.
 *
 * Note this is the inverse of LenderFeeDisplay, which only appears when its rate is 0.
 */
export const BusinessFeeDisplay = ({ calculatedRate }: BusinessFeeDisplayProps) => {
  const { t } = useTranslation()
  const {
    methods: { control },
  } = useFormContainerContext<PersonalLoanCalculatorSchemaType>()
  const showBusinessFee = useWatch({ control, name: 'showBusinessFee' })

  if (!calculatedRate?.merchantFeeRate) return null

  return (
    <FieldsetCard
      title={t('calculator.businessFeeTitle')}
      subtitle={t('calculator.businessFeeDescription')}
      action={
        <ControlledSwitch
          control={control}
          name="showBusinessFee"
          label=""
          controlProps={{ inputProps: { 'aria-label': t('calculator.businessFeeTitle') } }}
        />
      }
    >
      {showBusinessFee && (
        <DataField label={t('calculator.feeRateLabel')} value={`${calculatedRate.merchantFeeRate} %`} />
      )}
    </FieldsetCard>
  )
}
